import { useEffect, useState } from 'react';
import { getQueryParam } from '../util';
const defaultStartMessageFilter = (message) => { var _a; return ((_a = message.data) === null || _a === void 0 ? void 0 : _a.type) === 'webchat/start'; };
const bootstrappedStart = { isStarted: true, trigger: 'bootstrap' };
export const useWebChatStart = (startMessageFilter = defaultStartMessageFilter) => {
    var _a;
    if (((_a = getQueryParam('bootstrap')) === null || _a === void 0 ? void 0 : _a.toLowerCase()) == 'true') {
        return bootstrappedStart;
    }
    const [webChatStart, setWebChatStart] = useState({ isStarted: false });
    useEffect(() => {
        const handleMessage = (message) => {
            if (!webChatStart.isStarted) {
                if (startMessageFilter(message)) {
                    window.removeEventListener('message', handleMessage);
                    setWebChatStart({ isStarted: true, trigger: message });
                }
            }
        };
        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, []);
    return webChatStart;
};
//# sourceMappingURL=useWebChatStart.js.map